import React from 'react';
import './CourseItem.less';
import Picture from '../../../../components/picture/Picture';
import { digitFormat } from '../../../../lib/utils/UtilsFormatter';
import { getJumpLink } from '../../../../lib/utils/UtilsCommon';
import { autobind } from 'core-decorators';

/**
 * 可选参数
 */
interface IProps {
	businessId: string;
	poster: string;
	title: string;
	learningNum?: number;
	topicNum?: number;
	businessType: string;
	playing?: any;
	auditionPause?: any;
	playStatus?: any;
	selctId?: any;
}

/**
 * 页眉
 */
@autobind
class CourseItem extends React.PureComponent<IProps> {
	/**
	 * 播放
	 */
	public onPlaying(e: any): void {
		e.preventDefault();
		e.stopPropagation();
		const { businessId, businessType, selctId, playStatus } = this.props;
		if (businessId === selctId && Object.is(playStatus, 'playing')) {
			this.props.auditionPause();
		} else {
			if (this.props.playing) this.props.playing(businessType, businessId);
		}
	}

	/**
	 * render
	 */
	public render(): any {
		return (
			<a href={getJumpLink(this.props.businessType, this.props.businessId)} className="p-course-item">
				<div className="item-poster">
					<Picture placeholder src={this.props.poster} />
				</div>
				<p className="item-title elli-text">{this.props.title}</p>
				<div className="item-desc">
					<p>
						<span>{this.props.learningNum ? digitFormat(this.props.learningNum) : 0}学习次数</span>
						&nbsp;|&nbsp;
						<span>{this.props.businessType === 'topic' ? '单课' : `${this.props.topicNum}课时`}</span>
					</p>
					{this.props.playing ? (
						<div
							className={`p-play-btn
								${this.props.playStatus === 'loading' && this.props.businessId === this.props.selctId ? ' loading' : ''}
								${this.props.playStatus === 'playing' && this.props.businessId === this.props.selctId ? ' playing' : ''}
							`}
							onClick={this.onPlaying}>
							试听
						</div>
					) : null}
				</div>
			</a>
		);
	}
}

export default CourseItem;
